import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from '@/shared';
import { useGetAgendamiento } from '@/shared/actions/erp';
import SaveAgendamientoOrdenTraslado from '../../components/save-agendamiento-orden-traslado/SaveAgendamientoOrdenTraslado';

export type AgendaRecoordinacionPyLPageProps = {};

const OrdenServicioAgendamientoPage: React.FC<
  AgendaRecoordinacionPyLPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_agendamiento);
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.trasladosPyLNav;
  const { id } = useParams();

  const { data, isLoading, isRefetching } = useGetAgendamiento(id!);

  useLoaders(isLoading || isRefetching);

  if (isLoading ) return null;

  if (!data?.data?.id_agendamiento)
    return <Navigate to={returnUrlAgendamientosPyLPage} />;

  return (
    <SaveAgendamientoOrdenTraslado
      title="Confirmar Traslado"
      agendamiento={data.data}
      enableGestionVenta={false}
    />
  );
};

export default OrdenServicioAgendamientoPage;
